import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function subscriptionDiscountValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent) return null; // form not ready

    const discountedPriceRaw = control.value;

    // If no price entered, let required/min validators handle it
    if (discountedPriceRaw === null || discountedPriceRaw === '' || discountedPriceRaw === undefined) {
      return null;
    }

    const discountedPrice = Number(discountedPriceRaw);
    if (isNaN(discountedPrice) || discountedPrice <= 0) {
      return null; // let other validators handle invalid input
    }

    // Get selected subscription plan
    const plan = control.parent.get('allowedLocationsList')?.value;
    if (!plan) return null;

    const monthlyPrice = Number(plan.monthlyPrice || 0);
    const yearlyPrice  = Number(plan.yearlyPrice || 0);

    // If plan has no prices, nothing to validate
    if (!monthlyPrice && !yearlyPrice) {
      return null;
    }

    // Validation logic
    const validMonthly = monthlyPrice > 0 && discountedPrice < monthlyPrice;
    const validYearly  = yearlyPrice  > 0 && discountedPrice < yearlyPrice;

    if (!validMonthly && !validYearly) {
      return { subscriptionDiscountInvalid: true };
    }

    return null; // valid
  };
}
